import React from 'react';
import PropTypes from 'prop-types';

import {Skeleton} from "@mui/material";
import {styled} from "@mui/material/styles";

import {greyishBlue50, greyishBlue100} from "assets/jss/main";

OrderCardSkeleton.propTypes = {
    cards: PropTypes.number,
};

const StyledBar = styled(Skeleton, {shouldForwardProp: (prop) => 'dark' !== prop})(({dark}) => ({
    transform: 'none',
    borderRadius: '4px',
    backgroundColor: dark ? greyishBlue100 : greyishBlue50,
    '&::after': {
        background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.55), transparent)',
        animationDelay: '0s',
        animationDuration: '1.2s'
    }
}));

const Row = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
});

const Bar = (props) => <StyledBar animation="wave" {...props}/>;

function Card() {
    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: '16px', padding: '16px', borderBottom: `1px solid ${greyishBlue100}`}}>
            <Row>
                <Bar dark width={90} height={16}/>
                <Bar width={70} height={14}/>
            </Row>
            <Row>
                <Bar dark width={140} height={16}/>
                <Bar width={60} height={14}/>
            </Row>
            <Row style={{justifyContent: 'space-between'}}>
                <Bar dark width={80} height={16}/>
                <Bar width={70} height={14}/>
            </Row>
            <Row>
                <Bar width={90} height={20} sx={{borderRadius: '999px'}}/>
            </Row>
            <Row>
                <Bar dark width={72} height={20} sx={{borderRadius: '4px'}}/>
                <Bar width={64} height={20} sx={{borderRadius: '4px'}}/>
            </Row>
            <Row style={{justifyContent: 'space-between'}}>
                <Bar width={100} height={16}/>
                <Bar dark width={90} height={40} sx={{borderRadius: '8px'}}/>
            </Row>
        </div>
    );
}

function OrderCardSkeleton({cards = 5}) {
    return (
        <>
            {Array.from({length: cards}, (_, index) => (
                <Card key={index}/>
            ))}
        </>
    );
}

export default OrderCardSkeleton;
